import FeatureBlock from "../../components/FeatureBlock/FeatureBlock";
import ThreeColumnBlock from "../../components/ThreeColumnBlock/ThreeColumnBlock";
import Carousel from "../../components/Carousel/Carousel";
import SectionBanner from "../../components/SectionBanner/SectionBanner";
import { HomeContent } from "./Home-Content";
import "./Home.scss";

const Home: React.FC = () => {
  return (
    <>
      <Carousel
        slideDelay={7}
        linkClass="carousel-custom-class"
        content={HomeContent.carousel}
      />

      <SectionBanner
        linkClass="bg-light-grey2 py-3"
        content={HomeContent.sectionBanner1}
      />

      <section className="container pt-5 mt-3">
        <FeatureBlock
          content={HomeContent.featureBlock1}
        />
      </section>

      <section className="container pt-5 mt-3">
        <FeatureBlock
          content={HomeContent.featureBlock2}
        />
      </section>

      <section className="container pt-5 pb-3 mt-3">
        <ThreeColumnBlock
          content={HomeContent.threeColumnBlock}
        />
      </section>

      <SectionBanner
        linkClass="bg-light-grey2 mt-5 py-4"
        content={HomeContent.sectionBanner2}
      />
    </>
  );
};

export default Home;
